const HORIZONTAL_DECK_CARDS_GAP = '0.5rem';
var CardMode;
(function (CardMode) {
    CardMode["DEFAULT"] = "default";
    CardMode["WIDE"] = "wide";
})(CardMode || (CardMode = {}));
var CardType;
(function (CardType) {
    CardType["DEFAULT"] = "default";
    CardType["FEATURED"] = "featured";
})(CardType || (CardType = {}));
export { CardMode, CardType, HORIZONTAL_DECK_CARDS_GAP, };
//# sourceMappingURL=card-constants.js.map